"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _icon = _interopRequireDefault(require("../icon"));
var _topnavModule = _interopRequireDefault(require("./topnav.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcTopNav(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].logo
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: "logo",
    size: {
      width: 100,
      height: 50
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].menuItems
  }, /*#__PURE__*/_react["default"].createElement("ul", null, props && props.menu.map(function (menu) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "/".concat(menu.path)
    }, /*#__PURE__*/_react["default"].createElement("li", {
      key: menu.path
    }, " ", menu.name, " ")));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topnavModule["default"].profile
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: "bell",
    size: {
      width: 24,
      height: 24
    }
  }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: "user",
    size: {
      width: 24,
      height: 24
    }
  })));
}
var _default = ArcTopNav;
exports["default"] = _default;